
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.4 4.4l4.537 5.67a1.4 1.4 0 01.307.876V15.6l1.4-1.05v-3.605a1.4 1.4 0 01.306-.874L15.488 4.4H4.4zm0-1.4h11.088a1.4 1.4 0 011.093 2.275l-4.537 5.67v3.605a1.4 1.4 0 01-.56 1.12l-1.4 1.05a1.4 1.4 0 01-2.24-1.12v-4.655l-4.537-5.67A1.4 1.4 0 014.4 3z"}})])
          )
        }
      }
    